import React from 'react'
import LineProgress from '../../../../../Reports/ExtemdedReport/components/shared/LineProgress'

const DisbursementProjectsIgr = ({ t, generalData }) => {
    return (
        <div className="disbursement">
            <h3 className="chart-title">{t('one_pager_report.year_disbursements')}</h3>
            <div className="chart-content">
                <LineProgress
                    format='USD'
                    totalDisbursed={generalData.projectionsDisbursementsYearPercent}
                    totalDisbursedPercent={generalData.projectionsDisbursementsYearPercent}
                    totalPending={generalData.projectionsDisbursementsYearPercent}
                    totalPendingPercent={generalData.projectionsDisbursementsYearPercent}
                />
            </div>
        </div>
    )
}

export default DisbursementProjectsIgr